import { observer } from 'mobx-react-lite';

import { MainLayout } from 'src/components/layouts/main-layout/MainLayout';

import { SettingsGrid } from './features/settings-grid/SettingsGrid';

export const SettingsPage = observer(function SettingsPage() {
  return (
    <MainLayout title="Settings">
      <SettingsGrid />
    </MainLayout>
  );
});
